import { createApp,defineAsyncComponent } from 'vue';
import moment from "moment/moment";
import VueImage from './Components/VueImage';
import RevealMenu from "./Components/RevealMenu";
//import GreenAudioPlayer from "./Components/GreenAudioPlayer";
import MailChimp from "./Components/Mailchimp";
import SideNavigation from "./Components/SideNavigation";
import Modal from "./Components/Modal";


//import CropMap from "./Scripts/crop-map.js";

const BinocularsMap = defineAsyncComponent(()=>import("./Components/BinocularsMap"));

const Carousel = defineAsyncComponent(() => import('./Components/Carousel'));

const MailchimpEmbed = defineAsyncComponent(()=>import("./Components/Mailchimp"));

// const PodcastPlayerEntry = defineAsyncComponent(()=>import('./Components/PodcastPlayerEntry'));
// const PodcastPlaylist = defineAsyncComponent(() => import('./Components/PodcastPlaylist'));
// const Podcastify = defineAsyncComponent(() => import('./Components/Podcastify'));
// const PodcastifyCompact = defineAsyncComponent(() => import('./Components/PodcastifyCompact'));
const PartnersMap = defineAsyncComponent(()=>import("./Components/PartnersMap"));

const SearchForStaticBanner = defineAsyncComponent(()=>import('./Components/SearchForStaticBanner'));
const DisplaySearchResults = defineAsyncComponent(() => import('./Components/DisplaySearchResults'));
const SearchResults = defineAsyncComponent(() => import('./Components/SearchResults'));
const KeywordResult = defineAsyncComponent(() => import('./Components/KeywordResult'));
const ViewArticleResultCard = defineAsyncComponent(() => import('./Components/ViewArticleResultCard'));
const ViewWebinarResultDropdown = defineAsyncComponent(()=> import('./Components/ViewWebinarResultDropdown'));

const WebBook = defineAsyncComponent(()=>import("./Components/WebBook"));

const Contributors = defineAsyncComponent(()=> import('./Components/Contributors'));
const Paginator = defineAsyncComponent( () => import("./Components/Paginator.vue"));
require('instant.page');

/**
 * Create a fresh Vue application instance and attach it to the page
 */
const app = createApp({})

/**
 * It is used for podcast audio files
 */
//app.component('green-audio-player', GreenAudioPlayer)

app.component('v-image', VueImage);
app.component('reveal-menu', RevealMenu);
app.component('side-navigation', SideNavigation);

app.component('binoculars-map', BinocularsMap);

app.component('carousel', Carousel);
app.component('modal', Modal);

app.component('mailchimp-embed', MailchimpEmbed);

// app.component('podcast-player-entry', PodcastPlayerEntry);
// app.component('podcast-playlist', PodcastPlaylist);
// app.component('podcastify', Podcastify);
// app.component('podcastify-compact', PodcastifyCompact);
app.component('partners-map', PartnersMap);

app.component('static-banner-search', SearchForStaticBanner);
app.component('display-search-results', DisplaySearchResults);
app.component('search-results', SearchResults);
app.component('view-article-result-card', ViewArticleResultCard);
app.component('view-webinar-result-dropdown',ViewWebinarResultDropdown);
app.component('keyword-result', KeywordResult);

app.component('web-book', WebBook);

app.component('contributors', Contributors);

app.component('paginator', Paginator);

app.config.globalProperties.moment = moment;

app.mount("#app");


// Efficacy Tables
var efficacyFiltersCropElement = document.getElementById("efficacy-filters-crop");
if (efficacyFiltersCropElement) {
    efficacyFiltersCropElement.addEventListener("change", refreshEfficacyTables);
}

var efficacyFiltersSortElements = document.getElementsByClassName("sortable");
for (let i = 0; i < efficacyFiltersSortElements.length; i++) {
    efficacyFiltersSortElements[i].addEventListener("click", resortEfficacyTables);
}

function resortEfficacyTables(elelment) {

    if (elelment.target.classList.contains('fa-solid')){
        var temptempid = elelment.target.id;
        var tempid = temptempid.slice(1);
    }else{
        var tempid = elelment.target.id;

    }


    if (document.getElementById("sort").value == tempid){
        if (document.getElementById("direction").value == "asc"){
            document.getElementById("direction").value = "desc";
        }else{
            document.getElementById("direction").value = "asc";
        }
    }else{
        if (tempid == "sort-product" || tempid == "sort-ingredient"){
            document.getElementById("direction").value = "asc";
        }else{
            document.getElementById("direction").value = "desc";
        }
    }

    document.getElementById("sort").value = tempid;
    document.getElementById("efficacyTable").submit();

}

function refreshEfficacyTables(cropid){

    var tempid = "efficacy-problem-"+cropid.target.value;

    // Get Data
    // var efficacyFiltersProblems = document.getElementsByClassName("efficacy-problem");
    // var efficacyFiltersProblems = document.getElementsByClassName("efficacy-problems-all");
    //
    // for (let i = 0; i < efficacyFiltersProblems.length; i++) {
    //     const element = efficacyFiltersProblems[i];
    //
    //     if (element.classList.contains(tempid)){
    //         element.classList.remove("hidden");
    //         element.classList.remove("hidden-option");
    //
    //     }else{
    //         element.classList.add("hidden");
    //         element.classList.add("hidden-option");
    //
    //     }
    //     //element.disabled = true;
    //
    // }

    const sourceSelect = document.getElementById('problemsAll');
    const targetSelect = document.getElementById('efficacy-filters-problemx');

    // Clear existing options in the target select
    targetSelect.innerHTML = '';

    // Clone and append options from the source select to the target select
    for (const option of sourceSelect.options) {
        console.log(option.classList);
        if (option.classList.contains("all") || option.classList.contains(tempid)){
            const clonedOption = option.cloneNode(true);
            targetSelect.appendChild(clonedOption);
        }

    }


    // Apply filters
    // var efficacyDataCropColumns = document.getElementsByClassName("efficacy-crop");
    //
    // for (const efficacyDataCrop of efficacyDataCropColumns) {
    //
    //     efficacyDataCrop.classList.add("hidden");
    //    if (efficacyDataCrop.classList.contains("efficacy-crop-"+efficacyFiltersCrop)){
    //        efficacyDataCrop.classList.remove("hidden");
    //
    //    }
    //
    // }


    //alert(efficacyFiltersCrop);





}




